'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@eliadmin/core/src/utils/style-utils';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    isDual?: boolean;
  }
>(({ className, isDual, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      'relative flex w-full touch-none select-none items-center overflow-visible',
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-[6px] w-full grow cursor-pointer overflow-visible rounded-full bg-input">
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
      {/* <SliderPrimitive.Range className="absolute h-full bg-primary" /> */}
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className={cn(
        'relative block h-[22px] w-[22px] cursor-pointer rounded-full bg-primary transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50',
        'ea-slider__thumb',
      )}
    />
    {isDual && (
      <SliderPrimitive.Thumb
        className={cn(
          'relative block h-[22px] w-[22px] cursor-pointer rounded-full bg-primary transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50',
          'ea-slider__thumb',
        )}
      />
    )}
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
